import JSEncrypt from 'onyx-common/jsencrypt'

const encrypt = new JSEncrypt()

export default encrypt
